import {Component, Input} from '@angular/core';
import {Unit} from '../../dashboard/monitoring/unit';
import {RouteLibraryService} from '../../route/route-library.service';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {RouteLibraryEntities} from '../../route/route-library-entity';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss']
})
export class OrderStatusComponent {
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  @Input() unitStatus: string;
  @Input() unit: Unit;

  constructor(
    public routeLibrary: RouteLibraryService,
    public immutableListRepositoryService: ImmutableListRepositoryService,
  ) {
  }
}
